import { INVITATION_MODELS } from "../../values/invitations";
import "./ModelsSection.css";

const ModelsSection = () => {
  return (
    <section className="modelos" id="invitaciones">
      <div className="container">
        <div className="row">
          {INVITATION_MODELS.map((model) => (
            <div key={model.id} className="col-md-4 text-center modelo">
              <a href={model.url} target="_blank" rel="noopener noreferrer">
                <img className="img-fluid" src={model.image} alt={model.name} />
              </a>
              <div className="container-fluid">
                <h2>{model.name}</h2>
                <p
                  dangerouslySetInnerHTML={{
                    __html: model.description.replaceAll(/\n/g, "<br/>"),
                  }}
                />
                <a
                  href={model.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`boton ${model.buttonClass}`}
                >
                  Ver {model.name.replace("Invitación ", "")}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ModelsSection;
